import React from 'react';
import { Button, Modal } from 'lmc-ui-library';
import styles from './../../CaseDetailsPage.module.scss';
import { useDispatch } from 'react-redux';
import { closePepperContext } from '../store/useCases';
import css from './Styles.module.scss';

const GeneralError = () => {
  const dispatch = useDispatch();

  return (
    <>
      <Modal.Header title="Something went wrong!" mode="error" className={styles.modalHeader} />
      <Modal.Content className={css.modalContent}>
        <div className={css.contentText}>An unexpected error occurs, please try again.</div>
      </Modal.Content>
      <Modal.Footer style={{ display: 'grid' }}>
        <Button
          mode="ghost"
          borderVariant="rectangle"
          className={styles.actionButton}
          onClick={dispatch.bind(null, closePepperContext())}>
          Close
        </Button>
      </Modal.Footer>
    </>
  );
};

export default GeneralError;
